import script from "./ClientsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsSection.vue?vue&type=script&setup=true&lang=js"

import "./ClientsSection.vue?vue&type=style&index=0&id=369646cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-369646cb"]])

export default __exports__